import React, { useState } from "react";
import { Button } from "@material-ui/core";
import Cell from "./cell";
import ImportCsv from "./importCsv";

// `apiTarget` serves the reference lookups the cells make (public API); `writeApiTarget`
// serves the CSV import, which is a write and therefore needs the VPN-only host.
const AddItemPage = ({
  apiTarget,
  writeApiTarget,
  tableName,
  columnsRes,
  saving,
  onSave,
  onCancel,
  dataRes,
  resRef,
}) => {
  const [item, setItem] = useState({});

  const _renderInputs = () => {
    return columnsRes?.map((column, index) => {
      const columnKey = column.name;
      let isReadOnly = ["_id", "_createdDate", "_updatedDate"].includes(
        columnKey
      );
      if (!isReadOnly && tableName === "users" && columnKey === "user") {
        isReadOnly = true;
      }

      return (
        <div key={`addItem_${columnKey}`} style={{ margin: "20px" }}>
          <div style={{ fontSize: "12px", color: "grey" }}>
            {`${column?.reference || column?.type}`}
          </div>
          <div>{columnKey}</div>

          <Cell
            readOnly={isReadOnly}
            style={{
              width: "380px",
              border: "1px solid black",
              backgroundColor: isReadOnly ? "grey" : "white",
            }}
            // refRes={refRes}
            type={column?.reference ? "reference" : column?.type}
            refColumn={column?.reference}
            refItems={
              column?.reference
                ? dataRes.map((d) => d[columnKey]).filter((d) => d)
                : null
            }
            onCellChange={(value) => {
              const newItem = { ...item };
              newItem[columnKey] = value;
              setItem(newItem);
            }}
            refRes={resRef}
            apiTarget={apiTarget}
          />
        </div>
      );
    });
  };

  return (
    <div>
      <ImportCsv apiTarget={writeApiTarget} table={tableName} />
      <Button
        style={{
          margin: "0 20px",
          color: "white",
          backgroundColor: saving ? "grey" : "#4eb7f5",
        }}
        onClick={() => {
          onSave(item);
        }}
      >
        {`Save`}
      </Button>

      <Button
        style={{
          margin: "0 20px",
          color: "white",
          backgroundColor: saving ? "grey" : "#f66",
        }}
        onClick={() => {
          if (!saving) onCancel();
        }}
      >
        {`Cancel`}
      </Button>

      {_renderInputs()}
    </div>
  );
};
export default AddItemPage;
